// Generated by scripts/build-cover-gallery.ps1 from the local, untrusted source library.
export const coverGallery = [
    {
        "id":  "scene-01",
        "group":  "scene",
        "groupLabel":  "场景灵感",
        "title":  "餐饮酒店",
        "src":  "/cover-gallery/scene-01.jpg"
    },
    {
        "id":  "scene-02",
        "group":  "scene",
        "groupLabel":  "场景灵感",
        "title":  "单页合集",
        "src":  "/cover-gallery/scene-02.jpg"
    },
    {
        "id":  "scene-03",
        "group":  "scene",
        "groupLabel":  "场景灵感",
        "title":  "党政宣传",
        "src":  "/cover-gallery/scene-03.jpg"
    },
    {
        "id":  "scene-04",
        "group":  "scene",
        "groupLabel":  "场景灵感",
        "title":  "读书分享",
        "src":  "/cover-gallery/scene-04.jpg"
    },
    {
        "id":  "scene-05",
        "group":  "scene",
        "groupLabel":  "场景灵感",
        "title":  "发布会",
        "src":  "/cover-gallery/scene-05.jpg"
    },
    {
        "id":  "scene-06",
        "group":  "scene",
        "groupLabel":  "场景灵感",
        "title":  "活动庆典",
        "src":  "/cover-gallery/scene-06.jpg"
    },
    {
        "id":  "scene-07",
        "group":  "scene",
        "groupLabel":  "场景灵感",
        "title":  "健康医疗",
        "src":  "/cover-gallery/scene-07.jpg"
    },
    {
        "id":  "scene-08",
        "group":  "scene",
        "groupLabel":  "场景灵感",
        "title":  "教育教学",
        "src":  "/cover-gallery/scene-08.jpg"
    },
    {
        "id":  "scene-09",
        "group":  "scene",
        "groupLabel":  "场景灵感",
        "title":  "节日节气",
        "src":  "/cover-gallery/scene-09.jpg"
    },
    {
        "id":  "scene-10",
        "group":  "scene",
        "groupLabel":  "场景灵感",
        "title":  "卡通绘图",
        "src":  "/cover-gallery/scene-10.jpg"
    },
    {
        "id":  "scene-11",
        "group":  "scene",
        "groupLabel":  "场景灵感",
        "title":  "逻辑架构",
        "src":  "/cover-gallery/scene-11.jpg"
    },
    {
        "id":  "scene-12",
        "group":  "scene",
        "groupLabel":  "场景灵感",
        "title":  "能源环保",
        "src":  "/cover-gallery/scene-12.jpg"
    },
    {
        "id":  "scene-13",
        "group":  "scene",
        "groupLabel":  "场景灵感",
        "title":  "培训管理",
        "src":  "/cover-gallery/scene-13.jpg"
    },
    {
        "id":  "scene-14",
        "group":  "scene",
        "groupLabel":  "场景灵感",
        "title":  "其他场景",
        "src":  "/cover-gallery/scene-14.jpg"
    },
    {
        "id":  "scene-15",
        "group":  "scene",
        "groupLabel":  "场景灵感",
        "title":  "企业介绍",
        "src":  "/cover-gallery/scene-15.jpg"
    },
    {
        "id":  "scene-16",
        "group":  "scene",
        "groupLabel":  "场景灵感",
        "title":  "求职简历",
        "src":  "/cover-gallery/scene-16.jpg"
    },
    {
        "id":  "scene-17",
        "group":  "scene",
        "groupLabel":  "场景灵感",
        "title":  "商业计划",
        "src":  "/cover-gallery/scene-17.jpg"
    },
    {
        "id":  "scene-18",
        "group":  "scene",
        "groupLabel":  "场景灵感",
        "title":  "述职竞聘",
        "src":  "/cover-gallery/scene-18.jpg"
    },
    {
        "id":  "scene-19",
        "group":  "scene",
        "groupLabel":  "场景灵感",
        "title":  "文化旅游",
        "src":  "/cover-gallery/scene-19.jpg"
    },
    {
        "id":  "scene-20",
        "group":  "scene",
        "groupLabel":  "场景灵感",
        "title":  "学术答辩",
        "src":  "/cover-gallery/scene-20.jpg"
    },
    {
        "id":  "scene-21",
        "group":  "scene",
        "groupLabel":  "场景灵感",
        "title":  "研究报告",
        "src":  "/cover-gallery/scene-21.jpg"
    },
    {
        "id":  "scene-22",
        "group":  "scene",
        "groupLabel":  "场景灵感",
        "title":  "营销策划",
        "src":  "/cover-gallery/scene-22.jpg"
    },
    {
        "id":  "scene-23",
        "group":  "scene",
        "groupLabel":  "场景灵感",
        "title":  "游戏-生活娱乐",
        "src":  "/cover-gallery/scene-23.jpg"
    },
    {
        "id":  "scene-24",
        "group":  "scene",
        "groupLabel":  "场景灵感",
        "title":  "总结汇报-计划",
        "src":  "/cover-gallery/scene-24.jpg"
    },
    {
        "id":  "industry-01",
        "group":  "industry",
        "groupLabel":  "行业灵感",
        "title":  "IT互联网",
        "src":  "/cover-gallery/industry-01.jpg"
    },
    {
        "id":  "industry-02",
        "group":  "industry",
        "groupLabel":  "行业灵感",
        "title":  "财务金融",
        "src":  "/cover-gallery/industry-02.jpg"
    },
    {
        "id":  "industry-03",
        "group":  "industry",
        "groupLabel":  "行业灵感",
        "title":  "餐饮-旅游",
        "src":  "/cover-gallery/industry-03.jpg"
    },
    {
        "id":  "industry-04",
        "group":  "industry",
        "groupLabel":  "行业灵感",
        "title":  "党政机关",
        "src":  "/cover-gallery/industry-04.jpg"
    },
    {
        "id":  "industry-05",
        "group":  "industry",
        "groupLabel":  "行业灵感",
        "title":  "地产家居",
        "src":  "/cover-gallery/industry-05.jpg"
    },
    {
        "id":  "industry-06",
        "group":  "industry",
        "groupLabel":  "行业灵感",
        "title":  "电子科技",
        "src":  "/cover-gallery/industry-06.jpg"
    },
    {
        "id":  "industry-07",
        "group":  "industry",
        "groupLabel":  "行业灵感",
        "title":  "法律税务",
        "src":  "/cover-gallery/industry-07.jpg"
    },
    {
        "id":  "industry-08",
        "group":  "industry",
        "groupLabel":  "行业灵感",
        "title":  "服装时尚",
        "src":  "/cover-gallery/industry-08.jpg"
    },
    {
        "id":  "industry-09",
        "group":  "industry",
        "groupLabel":  "行业灵感",
        "title":  "广告艺术",
        "src":  "/cover-gallery/industry-09.jpg"
    },
    {
        "id":  "industry-10",
        "group":  "industry",
        "groupLabel":  "行业灵感",
        "title":  "机械工业",
        "src":  "/cover-gallery/industry-10.jpg"
    },
    {
        "id":  "industry-11",
        "group":  "industry",
        "groupLabel":  "行业灵感",
        "title":  "机械制造",
        "src":  "/cover-gallery/industry-11.jpg"
    },
    {
        "id":  "industry-12",
        "group":  "industry",
        "groupLabel":  "行业灵感",
        "title":  "健康医疗",
        "src":  "/cover-gallery/industry-12.jpg"
    },
    {
        "id":  "industry-13",
        "group":  "industry",
        "groupLabel":  "行业灵感",
        "title":  "交通运输-汽车",
        "src":  "/cover-gallery/industry-13.jpg"
    },
    {
        "id":  "industry-14",
        "group":  "industry",
        "groupLabel":  "行业灵感",
        "title":  "教育培训",
        "src":  "/cover-gallery/industry-14.jpg"
    },
    {
        "id":  "industry-15",
        "group":  "industry",
        "groupLabel":  "行业灵感",
        "title":  "媒体传媒",
        "src":  "/cover-gallery/industry-15.jpg"
    },
    {
        "id":  "industry-16",
        "group":  "industry",
        "groupLabel":  "行业灵感",
        "title":  "能源环保",
        "src":  "/cover-gallery/industry-16.jpg"
    },
    {
        "id":  "industry-17",
        "group":  "industry",
        "groupLabel":  "行业灵感",
        "title":  "农业生产",
        "src":  "/cover-gallery/industry-17.jpg"
    },
    {
        "id":  "industry-18",
        "group":  "industry",
        "groupLabel":  "行业灵感",
        "title":  "其他行业",
        "src":  "/cover-gallery/industry-18.jpg"
    },
    {
        "id":  "industry-19",
        "group":  "industry",
        "groupLabel":  "行业灵感",
        "title":  "人资行政",
        "src":  "/cover-gallery/industry-19.jpg"
    },
    {
        "id":  "industry-20",
        "group":  "industry",
        "groupLabel":  "行业灵感",
        "title":  "市场营销",
        "src":  "/cover-gallery/industry-20.jpg"
    },
    {
        "id":  "industry-21",
        "group":  "industry",
        "groupLabel":  "行业灵感",
        "title":  "体育文化",
        "src":  "/cover-gallery/industry-21.jpg"
    },
    {
        "id":  "industry-22",
        "group":  "industry",
        "groupLabel":  "行业灵感",
        "title":  "行业通用",
        "src":  "/cover-gallery/industry-22.jpg"
    },
    {
        "id":  "industry-23",
        "group":  "industry",
        "groupLabel":  "行业灵感",
        "title":  "游戏娱乐",
        "src":  "/cover-gallery/industry-23.jpg"
    }
] as const;

export type CoverGalleryItem = (typeof coverGallery)[number];